import { useMemo } from "react";
import { ResponsiveSankey } from "@nivo/sankey";
import { JourneyLink } from "./Journey.model";

type JourneySankeyChartProps = {
  nodes: { id: string }[];
  links: JourneyLink[];
};

const SANKEY_PROPS = {
  margin: { top: 20, right: 20, bottom: 20, left: 20 },
  linkOpacity: 0.8,
  linkHoverOpacity: 0.7,
  nodeOpacity: 1,
  nodeHoverOpacity: 1,
  nodeThickness: 18,
  nodeSpacing: 32,
  nodeBorderWidth: 0,
  nodeBorderColor: { from: "color", modifiers: [["darker", 0.8]] as const },
  linkBlendMode: "normal" as const,
  linkContract: 3,
  enableLinkGradient: true,
  labelPosition: "inside" as const,
  labelOrientation: "horizontal" as const,
  labelPadding: 12,
  labelTextColor: { from: "color", modifiers: [["darker", 6]] as const },
  animate: true,
  motionConfig: "gentle" as const,
};

const JourneySankeyChart = ({ nodes, links }: JourneySankeyChartProps) => {
  const data = useMemo(
    () => ({ nodes, links }),
    [nodes, links]
  );

  return (
    <ResponsiveSankey
      data={data}
      {...SANKEY_PROPS}
    />
  );
};

export default JourneySankeyChart;
